import { merge } from "lodash-es";
import frJson from "./fr.json";
import { CONCILIATION_FR_FR } from "#pages/backoffice/conciliation/translations/conciliation-fr-fr";

const fr = merge(frJson, { backoffice: { conciliation: CONCILIATION_FR_FR } });

export { fr };
